// Copyright (c) 2023 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

const FormActions = props =>

    <div className='form-actions'>
        <div> { props.status === 'APPROVED' ?
            <button
                className='primary'
                onClick={props.handleInprocess}
                tabIndex='16'
                type='button'
            >
                <FormattedMessage id='MARK_AS_INPROCESS'/>
            </button> : null
            }

            <button
                className='primary'
                disabled={props.isUpdateDisabled}
                onClick={props.handleUpdate}
                tabIndex='16'
                type='button'
            >
                <FormattedMessage id='UPDATE'/>
            </button>
            { props.status === '' ?
                <button
                    className='primary'
                    disabled={props.isDisabled}
                    onClick={props.handleSubmit}
                    tabIndex='16'
                    type='button'
                >
                    <FormattedMessage id='SUBMIT'/>
                </button> : null}
            { props.status === '' ?
                <button
                    className='button-secondary'
                    disabled={props.status !== ''}
                    onClick={props.handleCancle}
                    tabIndex='16'
                    type='button'
                >
                    <FormattedMessage id='CANCEL'/>
                </button> : null}
        </div>
    </div>;

FormActions.displayName = 'FormActions';
FormActions.propTypes = {
    handleCancle: PropTypes.func.isRequired,
    handleInprocess: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func,
    isDisabled: PropTypes.bool.isRequired,
    isUpdateDisabled: PropTypes.bool.isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    status: PropTypes.string.isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default FormActions;



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/components/duplicate-pin-plate-form/form-actions.js